import React from "react";
import Carousel from "react-multi-carousel";
import { useNavigate } from "react-router-dom";

import coffee from "../../assets/images/coffee.png";
import shadowRight from "../../assets/images/rightHereShadowRight.png";

const CustomLeftArrow = ({ onClick, carouselState }) => {
  const { currentSlide } = carouselState;

  if (currentSlide === 0) return null;

  return (
    <button className="custom-arrow left" onClick={onClick}>
      <i className="ri-arrow-left-line"></i>
    </button>
  );
};

const CustomRightArrow = ({ onClick, carouselState }) => {
  const { currentSlide, totalItems, slidesToShow } = carouselState;

  if (currentSlide + slidesToShow >= totalItems) return null;

  return (
    <button className="custom-arrow right" onClick={onClick}>
      <i className="ri-arrow-right-line"></i>
    </button>
  );
};

const RightHere = ({ categories = [], loading }) => {
  const navigate = useNavigate();

  const responsive = {
    desktop: { breakpoint: { max: 3000, min: 1390 }, items: 6 },
    tablet: { breakpoint: { max: 1390, min: 980 }, items: 4 },
    mobile: { breakpoint: { max: 980, min: 450 }, items: 3 },
    mobileMin1: { breakpoint: { max: 450, min: 0 }, items: 2 },
  };

  return (
    <section id="right-here">
      <div className="wrapper">
        <h2>EVERYTHING YOU NEED, RIGHT HERE</h2>

        <div className="right-here-container">
          {/* <div className="find-favorites">
            <div className="fint-content">
              <p className="fav-para">Find all your favorites in one place.</p>

              <button className="visit-fav" onClick={() => navigate("/store")}>
                visit store
              </button>
            </div>
          </div> */}

          <div className="shadow-container">
            <img src={shadowRight} className="shadow-right" alt="" />

            {!loading && categories.length === 0 ? (
              <p className="section-empty-message">No items available right now.</p>
            ) : (
              <Carousel
                responsive={responsive}
                infinite={false}
                arrows
                customLeftArrow={<CustomLeftArrow />}
                customRightArrow={<CustomRightArrow />}
              >
                {categories.map((item) => (
                  <div
                    className="right-item"
                    key={item.CategoryId}
                    // onClick={() =>
                    //   navigate(`/store?categoryId=${item.CategoryId}`)
                    // }
                  >
                    <div className="mains-img">
                      <img src={item.CategoryPicture?.Url || coffee} alt={item.CategoryName} className="img-favor" />
                    </div>

                    <p>{item.CategoryName}</p>
                  </div>
                ))}
              </Carousel>
            )}
          </div>
        </div>
        <button className="visit-store" onClick={() => navigate("/store")}>
          VISIT STORE
        </button>
      </div>
    </section>
  );
};

export default RightHere;
